exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-survey {\n  margin: 8px 0;\n  padding: 8px; }\n\n.survey-title {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  gap: 20px;\n  -ms-flex-align: center;\n      align-items: center; }\n\n.divider {\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n  border: 0;\n  border-top: 1px solid rgba(0, 0, 0, 0.1); }\n\n.tuple {\n  background-color: #F5F5F5;\n  padding: 10px;\n  border-radius: 4px;\n  margin-bottom: 10px; }\n\n.not-filled {\n  font-style: italic;\n  color: #AAAAAA; }\n\n.table-field {\n  margin-bottom: 10px; }\n\n.table-simple-value {\n  background-color: #FFFFFF;\n  padding: 6px;\n  border-color: #DBDBDB;\n  border-width: 1px;\n  display: block;\n  margin-top: 5px;\n  max-width: 60%;\n  margin-right: 40%; }\n\n.block-title {\n  font-weight: bolder;\n  margin-top: 20px; }\n\n.named-block {\n  margin-top: 10px;\n  margin-bottom: 10px;\n  padding: 10px;\n  border-width: 1px;\n  border-radius: 4px;\n  border-color: #E1E1E1;\n  border-style: solid;\n  background-color: #FAFAFA; }\n\n.text-field {\n  overflow-wrap: break-word; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/SPA/src/app/client/components/survey/survey.component.scss
// module id = ../../../../../src/app/client/components/survey/survey.component.scss
// module chunks = 0